export const merchandise = {
  'zh-CN': {
    // 商品管理
    goodsManagement: '商品管理',
    goodsDetails: '商品详情',
    addGoods: '添加商品',
    editGoods: '编辑商品',
    deleteGoods: '删除商品',
    goodsList: '商品列表',
    goodsCategory: '商品分类',
    goodsStatus: '商品状态',
    
    // 商品信息
    goodsName: '商品名称',
    goodsPrice: '商品价格',
    goodsStock: '商品库存',
    goodsDescription: '商品描述',
    goodsImage: '商品图片',
    goodsCode: '商品编码',
    goodsBrand: '商品品牌',
    goodsModel: '商品型号',
    
    // 运费管理
    freightManagement: '运费管理',
    freightTemplate: '运费模板',
    freightRule: '运费规则',
    freeShipping: '包邮',
    weightBased: '按重量计费',
    quantityBased: '按数量计费',
    templateName: '模板名称',
    updateTime: '更新时间',
    relatedGoods: '关联商品',
    operation: '操作',
    detail: '详情',
    search: '搜索',
    pleaseEnterTemplateName: '请输入运费模板名称',
    createNewTemplate: '+新建运费模板',
    
    // 商品预览
    preview: '预览',
    share: '分享',
    product: '产品',
    call: '通话',
    favorite: '收藏',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    type: '类型',
    specification: '规格',
    productDetails: '宝贝详情',
    bottomReached: '到底了，看看其他的吧',
    
    // 商品信息
    goodsSpecification: '商品规格',
    goodsDetails: '商品详情',
    goodsType: '商品分类',
    goodsTypeName: '商品分类名称',
    stockNum: '库存数量',
    price: '零售价',
    wholesalePrice: '批发价',
    maxPrice: '最高价格',
    specName: '规格名称',
    specAttribute: '规格属性',
    yuan: '港元',
    
    // 预约管理
    appointmentManagement: '预约管理',
    appointmentList: '预约列表',
    appointmentStatus: '预约状态',
    appointmentTime: '预约时间',
    appointmentRemark: '预约备注',
    
    // 商品管理页面
    goodsNumber: '商品编号',
    category: '分类',
    totalStock: '总库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    resaleStatus: '是否跟卖',
    resale: '跟卖',
    resaleCount: '被跟卖次数',
    resaleGoodsSpecTip: '跟卖商品仅允许修改价格，不能修改规格名称和规格属性',
    sort: '排序',
    sortTip: '数值越大，商品排序越靠前',
    noImage: '暂无图片',
    details: '详情',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确认删除？',
    online: '上架',
    offline: '下架',
    search: '搜索',
    all: '全部',
    yes: '是',
    no: '否',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    noPermission: '暂无权限',
    saveSuccess: '保存成功',
    sortCannotEmpty: '排序不能为空',
    categoryName: '分类名称',
    categoryNumber: '分类编号',
    goodsCount: '商品数量',
    addCategory: '添加分类',
    editCategory: '编辑分类',
    inputCategoryName: '请输入分类名称',
    addSuccess: '添加成功',
    editSuccess: '编辑成功',
    operationCancel: '取消操作',
    
    // 预约列表
    productId: '产品ID',
    productName: '产品名称',
    userName: '用户姓名',
    appointmentPhone: '预约电话',
    orderTime: '下单时间',
    remark: '备注',
    cancelReason: '取消原因',
    status: '状态',
    operation: '操作',
    cancelAppointment: '取消预约',
    confirmAppointment: '确认预约',
    pendingConfirm: '待确认',
    confirmed: '已确认',
    completed: '已完成',
    cancelled: '已取消',
    expired: '已过期',
    
    // 商品列表
    publishGoods: '发布商品',
    moveUp: '上移',
    moveDown: '下移',
    confirmDeleteGoods: '确定删除该商品？',
    
    // 产品分类
    newCategory: '新建分类',
    categoryId: '分类ID',
    deleteCategory: '删除分类',
    deleteCategoryConfirm: '此操作将永久删除该分类, 是否继续?',
    
    // 通用
    query: '查询',
    selectDate: '选择日期',
    pleaseSelect: '请选择',
    inputCancelReason: '请输入取消理由',
    confirmAcceptAppointment: '确定接受此次预约么?',
    cancelInput: '取消输入',
    deleteForever: '此操作将永久删除该分类, 是否继续?',
    
    // 商品编辑/添加页面
    publishProcess: '发布流程：1.选择商品分类 ------ 2.输入商品基本信息 ------ 3.输入商品详情 ------ 4.发布商品',
    selectGoodsType: '1.选择商品类型',
    pleaseSelectGoodsType: '请选择商品类型',
    inputGoodsBasicInfo: '2.输入商品基本信息',
    goodsTitle: '商品标题',
    pleaseEnterGoodsName: '请选择商品名称',
    pleaseEnterGoodsStock: '请选择商品库存',
    goodsSpecification: '商品规格',
    pleaseEnterGoodsTypeName: '请输入商品类型名称',
    required: '必选',
    pleaseEnterGoodsSpecification: '请输入商品规格',
    pleaseEnterPrice: '请输入价格（单位：港元）',
    addAttribute: '添加属性',
    addSpecification: '添加规格',
    uploadImageTip: '上传图片的最佳尺寸：800像素*800像素，其他尺寸会影响页效果，格式png，jpeg，jpg。大小不超过4M，商品图片一共可以上传5张，默认第一张为主图封面',
    shareImage: '分享图片',
    shareImageTip: '上传图片及支持png/jpg 。显示图片长宽比为5:4',
    isDistribution: '是否参加分销',
    isShowDistributionText: '是否展示分销语',
    isPublishToProductCenter: '是否发布到产品中心',
    paymentMethod: '3.支付方式',
    onlinePayment: '线上支付',
    other: '其他',
    creditPayment: '信用额度',
    inputGoodsDetails: '4.输入商品详情',
    pleaseEnterGoodsDetails: '请填写商品详情',
    publish: '发布',
    preview: '预览',
    pleaseSelectCategory: '请选择分类！',
    pleaseEnterProductTitle: '请输入产品标题！',
    pleaseEnterStock: '请输入库存',
    pleaseEnterGoodsAttribute: '请输入商品属性',
    pleaseEnterDescription: '请输入描述',
    goodsImageNotUploaded: '商品图片未上传',
    shareImageNotUploaded: '商品分享图片未上传',
    pleaseCompleteGoodsSpecification: '请完善商品规格',
    publishFailed: '发布失败，请稍后再试',
    operationCancelled: '操作取消',
    uploading: '上传中，请稍等...',
    uploadSuccess: '上传成功',
    appointmentGoodsList: '预约商品列表',
    appointmentClassifyList: '预约分类列表',
    
    // 预约商品管理页面
    selectProductCategory: '1.选择产品分类',
    productCategory: '产品分类',
    inputProductBasicInfo: '2.输入产品基本信息',
    productTitle: '产品标题',
    pleaseEnterContent: '请输入内容',
    productPrice: '产品价格',
    specificAmount: '具体金额',
    rangeAmount: '区间金额',
    pleaseEnterSpecificAmount: '请输入具体金额',
    pleaseEnterRangeAmount: '请输入区间金额',
    productDescription: '产品简述',
    serviceMethod: '3.服务方式',
    serviceType: '服务方式',
    inStore: '到店',
    homeService: '上门',
    inputProductDetails: '4.输入产品详情',
    pleaseEnterProductTitle: '请输入产品标题！',
    pleaseEnterDescription: '请输入描述',
    pleaseUploadProductImage: '请上传商品图片',
    pleaseUploadShareImage: '请上传分享图片',
    pleaseSelectServiceType: '请选择服务方式！',
    uploadingImage: '正在上传',
    uploadSuccess: '上传成功',
    productImageNotUploaded: '商品图片未上传',
    productShareImageNotUploaded: '商品分享图片未上传',
    addNewCategory: '新增分类',
    pleaseEnterCategoryName: '请输入分类名称',
    pleaseEnterSpecificPrice: '请输入具体金额',
    pleaseEnterRangePrice: '请输入区间金额!',
    pleaseFillProductContent: '请填写商品内容',
    forMiniProgramShare: '用于小程序分享时展示图片'
  },
  'zh-TW': {
    // 商品管理
    goodsManagement: '商品管理',
    goodsDetails: '商品詳情',
    addGoods: '添加商品',
    editGoods: '編輯商品',
    deleteGoods: '刪除商品',
    goodsList: '商品列表',
    goodsCategory: '商品分類',
    goodsStatus: '商品狀態',
    
    // 商品信息
    goodsName: '商品名稱',
    goodsPrice: '商品價格',
    goodsStock: '商品庫存',
    goodsDescription: '商品描述',
    goodsImage: '商品圖片',
    goodsCode: '商品編碼',
    goodsBrand: '商品品牌',
    goodsModel: '商品型號',
    
    // 運費管理
    freightManagement: '運費管理',
    freightTemplate: '運費模板',
    freightRule: '運費規則',
    freeShipping: '包郵',
    weightBased: '按重量計費',
    quantityBased: '按數量計費',
    templateName: '模板名稱',
    updateTime: '更新時間',
    relatedGoods: '關聯商品',
    operation: '操作',
    detail: '詳情',
    search: '搜索',
    pleaseEnterTemplateName: '請輸入運費模板名稱',
    createNewTemplate: '+新建運費模板',
    
    // 商品预览
    preview: '預覽',
    share: '分享',
    product: '產品',
    call: '通話',
    favorite: '收藏',
    addToCart: '加入購物車',
    buyNow: '立即購買',
    type: '類型',
    specification: '規格',
    productDetails: '寶貝詳情',
    bottomReached: '到底了，看看其他的吧',
    
    // 商品信息
    goodsSpecification: '商品規格',
    goodsDetails: '商品詳情',
    goodsType: '商品分類',
    goodsTypeName: '商品分類名稱',
    stockNum: '庫存數量',
    price: '零售價',
    wholesalePrice: '批發價',
    maxPrice: '最高價格',
    specName: '規格名稱',
    specAttribute: '規格屬性',
    yuan: '港元',
    
    // 预约管理
    appointmentManagement: '預約管理',
    appointmentList: '預約列表',
    appointmentStatus: '預約狀態',
    appointmentTime: '預約時間',
    appointmentRemark: '預約備註',
    
    // 商品管理頁面
    goodsNumber: '商品編號',
    category: '分類',
    totalStock: '總庫存',
    totalSales: '總銷量',
    publishTime: '發布時間',
    resaleStatus: '是否跟賣',
    resale: '跟賣',
    resaleCount: '被跟賣次數',
    resaleGoodsSpecTip: '跟賣商品僅允許修改價格，不能修改規格名稱和規格屬性',
    sort: '排序',
    sortTip: '數值越大，商品排序越靠前',
    noImage: '暫無圖片',
    details: '詳情',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確認刪除？',
    online: '上架',
    offline: '下架',
    search: '搜索',
    all: '全部',
    yes: '是',
    no: '否',
    operationSuccess: '操作成功',
    operationFailed: '操作失敗',
    noPermission: '暫無權限',
    saveSuccess: '保存成功',
    sortCannotEmpty: '排序不能為空',
    categoryName: '分類名稱',
    categoryNumber: '分類編號',
    goodsCount: '商品數量',
    addCategory: '添加分類',
    editCategory: '編輯分類',
    inputCategoryName: '請輸入分類名稱',
    addSuccess: '添加成功',
    editSuccess: '編輯成功',
    operationCancel: '取消操作',
    
    // 预约列表
    productId: '產品ID',
    productName: '產品名稱',
    userName: '用戶姓名',
    appointmentPhone: '預約電話',
    orderTime: '下單時間',
    remark: '備註',
    cancelReason: '取消原因',
    status: '狀態',
    operation: '操作',
    cancelAppointment: '取消預約',
    confirmAppointment: '確認預約',
    pendingConfirm: '待確認',
    confirmed: '已確認',
    completed: '已完成',
    cancelled: '已取消',
    expired: '已過期',
    
    // 商品列表
    publishGoods: '發布商品',
    moveUp: '上移',
    moveDown: '下移',
    confirmDeleteGoods: '確定刪除該商品？',
    
    // 產品分類
    newCategory: '新建分類',
    categoryId: '分類ID',
    deleteCategory: '刪除分類',
    deleteCategoryConfirm: '此操作將永久刪除該分類, 是否繼續?',
    
    // 通用
    query: '查詢',
    selectDate: '選擇日期',
    pleaseSelect: '請選擇',
    inputCancelReason: '請輸入取消理由',
    confirmAcceptAppointment: '確定接受此次預約麼?',
    cancelInput: '取消輸入',
    deleteForever: '此操作將永久刪除該分類, 是否繼續?',
    
    // 商品編輯/添加頁面
    publishProcess: '發布流程：1.選擇商品分類 ------ 2.輸入商品基本信息 ------ 3.輸入商品詳情 ------ 4.發布商品',
    selectGoodsType: '1.選擇商品類型',
    pleaseSelectGoodsType: '請選擇商品類型',
    inputGoodsBasicInfo: '2.輸入商品基本信息',
    goodsTitle: '商品標題',
    pleaseEnterGoodsName: '請選擇商品名稱',
    pleaseEnterGoodsStock: '請選擇商品庫存',
    goodsSpecification: '商品規格',
    pleaseEnterGoodsTypeName: '請輸入商品類型名稱',
    required: '必選',
    pleaseEnterGoodsSpecification: '請輸入商品規格',
    pleaseEnterPrice: '請輸入價格（單位：港元）',
    addAttribute: '添加屬性',
    addSpecification: '添加規格',
    uploadImageTip: '上傳圖片的最佳尺寸：800像素*800像素，其他尺寸會影響頁效果，格式png，jpeg，jpg。大小不超過4M，商品圖片一共可以上傳5張，默認第一張為主圖封面',
    shareImage: '分享圖片',
    shareImageTip: '上傳圖片及支持png/jpg 。顯示圖片長寬比為5:4',
    isDistribution: '是否參加分銷',
    isShowDistributionText: '是否展示分銷語',
    isPublishToProductCenter: '是否發布到產品中心',
    paymentMethod: '3.支付方式',
    onlinePayment: '線上支付',
    other: '其他',
    creditPayment: '信用額度',
    inputGoodsDetails: '4.輸入商品詳情',
    pleaseEnterGoodsDetails: '請填寫商品詳情',
    publish: '發布',
    preview: '預覽',
    pleaseSelectCategory: '請選擇分類！',
    pleaseEnterProductTitle: '請輸入產品標題！',
    pleaseEnterStock: '請輸入庫存',
    pleaseEnterGoodsAttribute: '請輸入商品屬性',
    pleaseEnterDescription: '請輸入描述',
    goodsImageNotUploaded: '商品圖片未上傳',
    shareImageNotUploaded: '商品分享圖片未上傳',
    pleaseCompleteGoodsSpecification: '請完善商品規格',
    publishFailed: '發布失敗，請稍後再試',
    operationCancelled: '操作取消',
    uploading: '上傳中，請稍等...',
    uploadSuccess: '上傳成功',
    appointmentGoodsList: '預約商品列表',
    appointmentClassifyList: '預約分類列表',
    
    // 預約商品管理頁面
    selectProductCategory: '1.選擇產品分類',
    productCategory: '產品分類',
    inputProductBasicInfo: '2.輸入產品基本信息',
    productTitle: '產品標題',
    pleaseEnterContent: '請輸入內容',
    productPrice: '產品價格',
    specificAmount: '具體金額',
    rangeAmount: '區間金額',
    pleaseEnterSpecificAmount: '請輸入具體金額',
    pleaseEnterRangeAmount: '請輸入區間金額',
    productDescription: '產品簡述',
    serviceMethod: '3.服務方式',
    serviceType: '服務方式',
    inStore: '到店',
    homeService: '上門',
    inputProductDetails: '4.輸入產品詳情',
    pleaseEnterProductTitle: '請輸入產品標題！',
    pleaseEnterDescription: '請輸入描述',
    pleaseUploadProductImage: '請上傳商品圖片',
    pleaseUploadShareImage: '請上傳分享圖片',
    pleaseSelectServiceType: '請選擇服務方式！',
    uploadingImage: '正在上傳',
    uploadSuccess: '上傳成功',
    productImageNotUploaded: '商品圖片未上傳',
    productShareImageNotUploaded: '商品分享圖片未上傳',
    addNewCategory: '新增分類',
    pleaseEnterCategoryName: '請輸入分類名稱',
    pleaseEnterSpecificPrice: '請輸入具體金額',
    pleaseEnterRangePrice: '請輸入區間金額!',
    pleaseFillProductContent: '請填寫商品內容',
    forMiniProgramShare: '用於小程序分享時展示圖片'
  },
  'en': {
    // 商品管理
    goodsManagement: 'Goods Management',
    goodsDetails: 'Goods Details',
    addGoods: 'Add Goods',
    editGoods: 'Edit Goods',
    deleteGoods: 'Delete Goods',
    goodsList: 'Goods List',
    goodsCategory: 'Goods Category',
    goodsStatus: 'Goods Status',
    
    // 商品信息
    goodsName: 'Goods Name',
    goodsPrice: 'Goods Price',
    goodsStock: 'Goods Stock',
    goodsDescription: 'Goods Description',
    goodsImage: 'Goods Image',
    goodsCode: 'Goods Code',
    goodsBrand: 'Goods Brand',
    goodsModel: 'Goods Model',
    
    // 运费管理
    freightManagement: 'Freight Management',
    freightTemplate: 'Freight Template',
    freightRule: 'Freight Rule',
    freeShipping: 'Free Shipping',
    weightBased: 'Weight Based',
    quantityBased: 'Quantity Based',
    templateName: 'Template Name',
    updateTime: 'Update Time',
    relatedGoods: 'Related Goods',
    operation: 'Operation',
    detail: 'Details',
    search: 'Search',
    pleaseEnterTemplateName: 'Please Enter Template Name',
    createNewTemplate: '+Create New Template',
    
    // 商品预览
    preview: 'Preview',
    share: 'Share',
    product: 'Product',
    call: 'Call',
    favorite: 'Favorite',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    type: 'Type',
    specification: 'Specification',
    productDetails: 'Product Details',
    bottomReached: 'Reached the bottom, check out others',
    
    // 商品信息
    goodsSpecification: 'Goods Specification',
    goodsDetails: 'Goods Details',
    goodsType: 'Goods Type',
    goodsTypeName: 'Goods Type Name',
    stockNum: 'Stock Number',
    price: 'Retail Price',
    wholesalePrice: 'Wholesale Price',
    maxPrice: 'Max Price',
    specName: 'Specification Name',
    specAttribute: 'Specification Attribute',
    yuan: 'HK$',
    
    // 预约管理
    appointmentManagement: 'Appointment Management',
    appointmentList: 'Appointment List',
    appointmentStatus: 'Appointment Status',
    appointmentTime: 'Appointment Time',
    appointmentRemark: 'Appointment Remark',
    
    // 商品管理页面
    goodsNumber: 'Goods Number',
    category: 'Category',
    totalStock: 'Total Stock',
    totalSales: 'Total Sales',
    publishTime: 'Publish Time',
    resaleStatus: 'Is Resale',
    resale: 'Resale',
    resaleCount: 'Resale Count',
    resaleGoodsSpecTip: 'Resale products can only modify prices, cannot modify spec names and attributes',
    sort: 'Sort',
    sortTip: 'Larger number means higher priority',
    noImage: 'No Image',
    details: 'Details',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete?',
    online: 'Online',
    offline: 'Offline',
    search: 'Search',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    operationSuccess: 'Operation Success',
    operationFailed: 'Operation Failed',
    noPermission: 'No Permission',
    saveSuccess: 'Save Success',
    sortCannotEmpty: 'Sort cannot be empty',
    categoryName: 'Category Name',
    categoryNumber: 'Category Number',
    goodsCount: 'Goods Count',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    inputCategoryName: 'Please enter category name',
    addSuccess: 'Add Success',
    editSuccess: 'Edit Success',
    operationCancel: 'Operation Cancel',
    
    // 预约列表
    productId: 'Product ID',
    productName: 'Product Name',
    userName: 'User Name',
    appointmentPhone: 'Appointment Phone',
    orderTime: 'Order Time',
    remark: 'Remark',
    cancelReason: 'Cancel Reason',
    status: 'Status',
    operation: 'Operation',
    cancelAppointment: 'Cancel Appointment',
    confirmAppointment: 'Confirm Appointment',
    pendingConfirm: 'Pending Confirm',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    expired: 'Expired',
    
    // 商品列表
    publishGoods: 'Publish Goods',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    confirmDeleteGoods: 'Are you sure to delete this product?',
    
    // 产品分类
    newCategory: 'New Category',
    categoryId: 'Category ID',
    deleteCategory: 'Delete Category',
    deleteCategoryConfirm: 'This operation will permanently delete this category, continue?',
    
    // 通用
    query: 'Query',
    selectDate: 'Select Date',
    pleaseSelect: 'Please Select',
    inputCancelReason: 'Please enter cancellation reason',
    confirmAcceptAppointment: 'Are you sure to accept this appointment?',
    cancelInput: 'Cancel Input',
    deleteForever: 'This operation will permanently delete this category, continue?',
    
    // 商品编辑/添加页面
    publishProcess: 'Publish Process: 1.Select Goods Category ------ 2.Enter Basic Goods Information ------ 3.Enter Goods Details ------ 4.Publish Goods',
    selectGoodsType: '1.Select Goods Type',
    pleaseSelectGoodsType: 'Please select goods type',
    inputGoodsBasicInfo: '2.Enter Basic Goods Information',
    goodsTitle: 'Goods Title',
    pleaseEnterGoodsName: 'Please enter goods name',
    pleaseEnterGoodsStock: 'Please enter goods stock',
    goodsSpecification: 'Goods Specification',
    pleaseEnterGoodsTypeName: 'Please enter goods type name',
    required: 'Required',
    pleaseEnterGoodsSpecification: 'Please enter goods specification',
    pleaseEnterPrice: 'Please enter price (unit: yuan)',
    addAttribute: 'Add Attribute',
    addSpecification: 'Add Specification',
    uploadImageTip: 'Best image size: 800px*800px, other sizes will affect page effect, formats png, jpeg, jpg. Size not exceeding 4M, up to 5 product images can be uploaded, the first one is the main cover by default',
    shareImage: 'Share Image',
    shareImageTip: 'Upload images support png/jpg. Display image aspect ratio is 5:4',
    isDistribution: 'Whether to participate in distribution',
    isShowDistributionText: 'Whether to show distribution text',
    isPublishToProductCenter: 'Whether to publish to product center',
    paymentMethod: '3.Payment Method',
    onlinePayment: 'Online Payment',
    other: 'Other',
    creditPayment: 'Credit Payment',
    inputGoodsDetails: '4.Enter Goods Details',
    pleaseEnterGoodsDetails: 'Please enter goods details',
    publish: 'Publish',
    preview: 'Preview',
    pleaseSelectCategory: 'Please select category!',
    pleaseEnterProductTitle: 'Please enter product title!',
    pleaseEnterStock: 'Please enter stock',
    pleaseEnterGoodsAttribute: 'Please enter goods attribute',
    pleaseEnterDescription: 'Please enter description',
    goodsImageNotUploaded: 'Goods image not uploaded',
    shareImageNotUploaded: 'Goods share image not uploaded',
    pleaseCompleteGoodsSpecification: 'Please complete goods specification',
    publishFailed: 'Publish failed, please try again later',
    operationCancelled: 'Operation cancelled',
    uploading: 'Uploading, please wait...',
    uploadSuccess: 'Upload success',
    appointmentGoodsList: 'Goods List',
    appointmentClassifyList: 'Classify List',
    
    // 预约商品管理页面
    selectProductCategory: '1.Select Product Category',
    productCategory: 'Product Category',
    inputProductBasicInfo: '2.Enter Product Basic Information',
    productTitle: 'Product Title',
    pleaseEnterContent: 'Please enter content',
    productPrice: 'Product Price',
    specificAmount: 'Specific Amount',
    rangeAmount: 'Range Amount',
    pleaseEnterSpecificAmount: 'Please enter specific amount',
    pleaseEnterRangeAmount: 'Please enter range amount',
    productDescription: 'Product Description',
    serviceMethod: '3.Service Method',
    serviceType: 'Service Type',
    inStore: 'In Store',
    homeService: 'Home Service',
    inputProductDetails: '4.Enter Product Details',
    pleaseEnterProductTitle: 'Please enter product title!',
    pleaseEnterDescription: 'Please enter description',
    pleaseUploadProductImage: 'Please upload product image',
    pleaseUploadShareImage: 'Please upload share image',
    pleaseSelectServiceType: 'Please select service type!',
    uploadingImage: 'Uploading',
    uploadSuccess: 'Upload success',
    productImageNotUploaded: 'Product image not uploaded',
    productShareImageNotUploaded: 'Product share image not uploaded',
    addNewCategory: 'Add New Category',
    pleaseEnterCategoryName: 'Please enter category name',
    pleaseEnterSpecificPrice: 'Please enter specific price',
    pleaseEnterRangePrice: 'Please enter range price!',
    pleaseFillProductContent: 'Please fill product content',
    forMiniProgramShare: 'For mini program share display image'
  }
}
